'use client';

import { c as _c } from "react/compiler-runtime";
import { Checkbox } from '@uzh-bf/design-system';
import { useParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useSWRConfig } from 'swr';
import useSWRMutation from 'swr/mutation';
import { checkLearningObjective } from '~/app/actions/learningObjective.server';
import { CACHE_KEYS } from '~/lib/cache';
import { useAuthToken } from '~/lib/hooks';
import { cn } from '~/lib/utils';
function StudentLearningObjective(t0) {
  const $ = _c(30);
  const {
    disabled,
    objectiveId,
    objectiveContent,
    initialChecked,
    className
  } = t0;
  const [checked, setChecked] = useState(initialChecked);
  const {
    mutate
  } = useSWRConfig();
  let t1;
  let t2;
  if ($[0] !== initialChecked) {
    t1 = () => {
      setChecked(initialChecked);
    };
    t2 = [initialChecked];
    $[0] = initialChecked;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const params = useParams();
  const jwt = useAuthToken();
  let t3;
  if ($[3] !== params.courseId || $[4] !== params.moduleId || $[5] !== params.unitId) {
    t3 = CACHE_KEYS.OBJECTIVE_PROGRESS({
      courseId: params.courseId,
      moduleId: params.moduleId,
      unitId: params.unitId
    });
    $[3] = params.courseId;
    $[4] = params.moduleId;
    $[5] = params.unitId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== mutate || $[8] !== params.courseId) {
    t4 = {
      revalidate: false,
      onSuccess: () => {
        mutate(key => key?.includes(CACHE_KEYS.OBJECTIVE_PROGRESS({
          courseId: params.courseId
        })) || key?.includes(CACHE_KEYS.BLOCK_PROGRESS({
          courseId: params.courseId
        })));
      }
    };
    $[7] = mutate;
    $[8] = params.courseId;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    trigger,
    isMutating
  } = useSWRMutation(t3, checkLearningObjective, t4);
  let t5;
  if ($[10] !== className) {
    t5 = cn("flex flex-row items-center gap-2", className);
    $[10] = className;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = disabled || isMutating;
  let t7;
  if ($[12] !== checked || $[13] !== jwt || $[14] !== objectiveId || $[15] !== params.courseId || $[16] !== params.moduleId || $[17] !== params.unitId || $[18] !== trigger) {
    t7 = () => {
      trigger({
        newValue: Boolean(!checked),
        unitId: Number(params.unitId),
        moduleId: Number(params.moduleId),
        courseId: Number(params.courseId),
        objectiveId,
        jwt
      });
      setChecked(_temp);
    };
    $[12] = checked;
    $[13] = jwt;
    $[14] = objectiveId;
    $[15] = params.courseId;
    $[16] = params.moduleId;
    $[17] = params.unitId;
    $[18] = trigger;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== checked || $[21] !== t6 || $[22] !== t7) {
    t8 = <Checkbox disabled={t6} checked={checked} onCheck={t7} />;
    $[20] = checked;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== objectiveContent) {
    t9 = <div className="text-sm">{objectiveContent}</div>;
    $[24] = objectiveContent;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t5 || $[27] !== t8 || $[28] !== t9) {
    t10 = <div className={t5}>{t8}{t9}</div>;
    $[26] = t5;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
}
function _temp(prev) {
  return !prev;
}
export default StudentLearningObjective;